export class CustomLocalStorage {
    isAvailable = false;

    constructor() {
        this.isAvailable = CustomLocalStorage.checkIsAvailable();
    }

    // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available/16427747#16427747
    static checkIsAvailable() {
        const test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }

    add(name, data) {
        if (this.isAvailable) {
            const oldValue = this.get(name);

            if (oldValue !== null && typeof oldValue === 'object') {
                data = { ...oldValue, ...data };
            }

            localStorage.setItem(name, JSON.stringify(data));
        }
    }

    get(name) {
        if (this.isAvailable) {
            try {
                const unparsedJSON = localStorage.getItem(name);
                const json = JSON.parse(unparsedJSON);

                return json ?? null;
            } catch (e) {
                return null;
            }
        }
    }

    remove(name, key = null) {
        if (this.isAvailable) {
            if (key !== null) {
                const data = this.get(name);

                if (typeof data === 'object' && data !== null) {
                    delete data[key];

                    if (Object.keys(data).length === 0) {
                        localStorage.removeItem(name);
                    } else {
                        localStorage.setItem(name, JSON.stringify(data));
                    }
                } else {
                    localStorage.removeItem(name);
                }
            } else {
                localStorage.removeItem(name);
            }
        }
    }
}

const LocalStorageHandler = new CustomLocalStorage();
export default LocalStorageHandler;
